export default __webpack_public_path__ + "static/media/icon_settingtype_Prong.54348842.png";